var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useState } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { TextField } from '@swiggy-private/dls-web-core/dist/components/TextField';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg16 as IconInfo } from '@swiggy-private/dls-web-icons/dist/web/generic/info';
// components
import { SuggestedKeywords } from '@/pages/instamart/campaign/create/widgets/Steps/Keywords/components/SuggestedKeywords';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignWriteTooltips } from '@/constants/tooltips';
import { Phrases } from '@/pages/instamart/campaign/create/widgets/Nudge/constants';
// defs
import { TextFieldTypes } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
// icons
import { IconBroadQuery, IconExactQuery, IconBidRupee, } from '@/constants/icons/svg';
// hooks
import useNudge from '@/hooks/useNudge';
// widgets
import Nudge from '@/pages/instamart/campaign/create/widgets/Nudge';
// styles
import styles from './KeywordSelect.module.scss';
import AsyncButton from '@/widgets/AsyncButton/AsyncButton';
import Tooltip from '@/components/Tooltip/Tooltip';
const STATIC = {
    HEADING: 'Choose Keywords for your Ads',
    SUBHEADING: 'Your Ad appears when customers search for these keywords. Here are some suggestions for you',
    ADD_KW_BUTTON_CTA: 'Add Keyword',
    ADD_KW_INPUT_LABEL: 'Or add your own Keywords',
    ADD_KW_LEGEND: 'Keyword Legend',
    BROAD_QUERY: 'BROAD QUERY VOLUME',
    EXACT_QUERY: 'EXACT QUERY VOLUME',
    FLOOR_PRICE: 'MINIMUM BID',
};
const pearlBlack = '#02060C';
const MINIMUM_KEYWORD_LEN = 2;
const KeywordSelect = (props) => {
    const { suggestedKeywords, onAddKeyword, onSelectKeyword, showRetry } = props;
    const { isKeywordNudgeVisible } = useNudge();
    const [keywordInput, setKeywordInput] = useState('');
    const handleKeywordInputChange = () => __awaiter(void 0, void 0, void 0, function* () {
        return onAddKeyword(keywordInput.trim().toLowerCase()).then(() => setKeywordInput(''));
    });
    const handleChipSelect = (newKeyword) => {
        newKeyword && onSelectKeyword(newKeyword);
    };
    const renderTitle = () => {
        return (React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.text },
                React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.title }, STATIC.HEADING),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, STATIC.SUBHEADING)),
            isKeywordNudgeVisible && (React.createElement("span", { className: styles.nudge },
                React.createElement(Nudge, { text: Phrases.MIN_KEYWORDS })))));
    };
    const renderKeywordLegends = () => {
        return (React.createElement("div", { className: styles.legends },
            React.createElement("div", { className: styles.legendsLabel },
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.legendsTitle }, STATIC.ADD_KW_LEGEND),
                React.createElement(Tooltip, { content: CampaignWriteTooltips.KEYWORD_LEGEND },
                    React.createElement(GenericIcon, { Icon: IconInfo, fillColor: DlsColorTokens.text_Low_Emphasis, className: styles.legendsTooltipIcon })),
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Bold, color: DlsColorTokens.text_Highest_Emphasis, className: styles.legendsTitle }, ":")),
            React.createElement("div", { className: styles.legendsList },
                React.createElement("div", { className: styles.legendsItem },
                    React.createElement(IconBidRupee, { className: styles.legendsIcon, fillColor: pearlBlack, opacity: 0.75 }),
                    React.createElement(Text, { variant: DlsFontVariants.discount_Subheader_S1 }, STATIC.FLOOR_PRICE)),
                React.createElement("div", { className: styles.legendsItem },
                    React.createElement(IconBroadQuery, { className: styles.legendsIcon, fillColor: "black", opacity: 0.5 }),
                    React.createElement(Text, { variant: DlsFontVariants.discount_Subheader_S1 }, STATIC.BROAD_QUERY)),
                React.createElement("div", { className: styles.legendsItem },
                    React.createElement(IconExactQuery, { className: styles.legendsIcon, fillColor: "black", opacity: 0.5 }),
                    React.createElement(Text, { variant: DlsFontVariants.discount_Subheader_S1 }, STATIC.EXACT_QUERY)))));
    };
    const renderSuggestedKeywords = () => {
        return (React.createElement("div", { className: styles.suggestedKeywords },
            React.createElement(SuggestedKeywords, { showRetry: showRetry, loading: props.loading, retryFetchSuggestedKeywords: props.retryFetchSuggestedKeywords, chips: suggestedKeywords, handleChipSelect: handleChipSelect }),
            renderKeywordLegends()));
    };
    const renderKeywordInputField = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Text, { variant: DlsFontVariants.button_Text_BT2 }, STATIC.ADD_KW_INPUT_LABEL),
            React.createElement("div", { className: styles.keyword },
                React.createElement("div", { className: styles.keywordUserInput },
                    React.createElement(TextField, { textFieldDetails: {
                            value: keywordInput,
                            type: TextFieldTypes.TEXT,
                            name: 'keyword',
                            label: '',
                            onChange: (val) => setKeywordInput(val),
                            isDisabled: false,
                        } })),
                React.createElement(AsyncButton, { variant: "primary", onClick: handleKeywordInputChange, className: styles.keywordButton, isDisabled: keywordInput.length < MINIMUM_KEYWORD_LEN }, STATIC.ADD_KW_BUTTON_CTA))));
    };
    return (React.createElement("div", { className: styles.contentWrapper },
        renderTitle(),
        suggestedKeywords && renderSuggestedKeywords(),
        renderKeywordInputField()));
};
export default KeywordSelect;
